const { hasOwnProperty } = Object.prototype

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return (
    (x === y && (x !== 0 || 1 / x === 1 / y)) || (x !== x && y !== y) // eslint-disable-line no-self-compare
  )
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
export function shallowEqual(objA, objB): boolean {
  if (
    typeof objA !== 'object' ||
    objA === null ||
    objA === undefined ||
    typeof objB !== 'object' ||
    objB === null ||
    objB === undefined
  ) {
    return false
  }

  if (is(objA, objB)) {
    return true
  }

  const keysA = Object.keys(objA)
  const keysB = Object.keys(objB)

  if (keysA.length !== keysB.length) {
    return false
  }

  // Test for A's keys different from B.
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < keysA.length; i++) {
    const currentKey = keysA[i]
    if (
      !hasOwnProperty.call(objB, currentKey) ||
      !is(objA[currentKey], objB[currentKey])
    ) {
      return false
    }
  }

  return true
}

export const capitalize = (str: string): string => {
  const [firstLetter, ...restWord] = str.trim()

  if (firstLetter === undefined) return ''

  return firstLetter.toUpperCase() + restWord.join('')
}
